import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

import trCommon from './locales/tr/common.json';
import trDashboard from './locales/tr/dashboard.json';
import trCarbon from './locales/tr/carbon.json';
import trSupplier from './locales/tr/supplier.json';
import trFacilities from './locales/tr/facilities.json';
import trValidation from './locales/tr/validation.json';
import trGri from './locales/tr/gri.json';
import trTsrs from './locales/tr/tsrs.json';

import enCommon from './locales/en/common.json';
import enDashboard from './locales/en/dashboard.json';
import enCarbon from './locales/en/carbon.json';
import enSupplier from './locales/en/supplier.json';
import enFacilities from './locales/en/facilities.json';
import enValidation from './locales/en/validation.json';
import enGri from './locales/en/gri.json';
import enTsrs from './locales/en/tsrs.json';

const silentLogger = {
  type: 'logger' as const,
  log: () => {},
  warn: () => {},
  error: () => {},
};

i18n
  .use(silentLogger as any)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      tr: {
        common: trCommon,
        dashboard: trDashboard,
        carbon: trCarbon,
        supplier: trSupplier,
        facilities: trFacilities,
        validation: trValidation,
        gri: trGri,
        tsrs: trTsrs
      },
      en: {
        common: enCommon,
        dashboard: enDashboard,
        carbon: enCarbon,
        supplier: enSupplier,
        facilities: enFacilities,
        validation: enValidation,
        gri: enGri,
        tsrs: enTsrs
      }
    },
    lng: 'tr',
    fallbackLng: 'tr',
    defaultNS: 'common',
    debug: false,
    showSupportNotice: false,
    logErrorFn: () => {},
    logWarnFn: () => {},
    logDebugFn: () => {},
    interpolation: {
      escapeValue: false
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
      lookupLocalStorage: 'i18nextLng'
    },
    react: {
      useSuspense: false
    }
  } as any);

if (typeof window !== 'undefined') {
  // Her zaman Türkçe'yi zorla
  localStorage.setItem('i18nextLng', 'tr');
  i18n.changeLanguage('tr');
}

// Dil değişikliğinde tüm bileşenlerin güncellenmesini sağla
i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = lng;
});

export default i18n;
